module.exports = __webpack_public_path__ + "site/img/7.5ec08198.jpg";